import { EArrowsSize, EControlType, ESizeType, IMedia } from '@cian/frontend-newbuilding-carousel-component';

export const SLIDER_MEDIA: IMedia[] = [
  {
    minWidth: -Infinity,
    maxWidth: 1024,
    settings: {
      draggable: true,
      elementsWidth: {
        content: {
          width: 100,
          type: ESizeType.PERCENT,
        },
        leftEar: {
          width: 0,
          type: ESizeType.PIXEL,
        },
        rightEar: {
          width: 0,
          type: ESizeType.PERCENT,
        },
        gap: {
          width: 0,
          type: ESizeType.PIXEL,
        },
      },
      height: {
        value: 100,
        type: ESizeType.PERCENT,
      },
      slidesToShow: 1,
      slidesToScroll: 1,
      defaultControls: [],
    },
  },
  {
    minWidth: 1025,
    maxWidth: Infinity,
    settings: {
      draggable: true,
      elementsWidth: {
        content: {
          width: 100,
          type: ESizeType.PERCENT,
        },
        leftEar: {
          width: 0,
          type: ESizeType.PIXEL,
        },
        rightEar: {
          width: 0,
          type: ESizeType.PERCENT,
        },
        gap: {
          width: 0,
          type: ESizeType.PIXEL,
        },
      },
      height: {
        value: 100,
        type: ESizeType.PERCENT,
      },
      slidesToShow: 1,
      slidesToScroll: 1,
      defaultControls: [{ type: EControlType.ARROWS }],
      arrowsSettings: {
        alwaysVisible: true,
        size: EArrowsSize.LARGE,
      },
    },
  },
];

export const SLIDER_FIRST_PAINT = {
  draggable: true,
  elementsWidth: {
    leftEar: {
      width: 0,
      type: ESizeType.PIXEL,
    },
    rightEar: {
      width: 0,
      type: ESizeType.PERCENT,
    },
    content: {
      width: 100,
      type: ESizeType.PERCENT,
    },
    gap: {
      width: 0,
      type: ESizeType.PIXEL,
    },
  },
  height: {
    value: 100,
    type: ESizeType.PERCENT,
  },
  slidesToShow: 1,
  defaultControls: [{ type: EControlType.ARROWS }],
  arrowsSettings: {
    alwaysVisible: true,
    size: EArrowsSize.LARGE,
  },
};
